import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ProgressSpinnerState } from './progress-spinner';

@Injectable()

export class ProgressSpinnerService {

    private loaderSubject = new Subject<ProgressSpinnerState>();

    progressSpinnerState = this.loaderSubject.asObservable();

    constructor() { }

    show() {
        this.loaderSubject.next(<ProgressSpinnerState>{show: true});
    }

    hide() {
        this.loaderSubject.next(<ProgressSpinnerState>{show: false});
    }
}